

















































import { Component } from 'vue-property-decorator';
import { GeneralLedgerAccountsModule } from '@/store/Accounting/GeneralLedgerAccountsModule';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import GeneralLedgerAccountState from "@/models/Accounting/GeneralLedgerAccounts/GeneralLedgerAccountState";
import ListUtils from '@/lib/listUtils';

@Component({ name: 'GeneralLedgerAccountFilterDialog' })
export default class extends SaascadaVueDialog {

    dialog = false;
    filterByAccountState: GeneralLedgerAccountState = null;

    get stateOptions() {
        return ListUtils.generalLedgerAccountStateOptions();
    }

    async clear() {
        // Clear local filters and product module filters
        this.filterByAccountState = null;
        GeneralLedgerAccountsModule.clearAllFilters();
        // Close dialog first then get products again
        this.dialog = false;
        await GeneralLedgerAccountsModule.getGeneralLedgerAccounts(1);
    }

    async cancel() {
        // Reset local filters back to matching the value of the module filters
        this.filterByAccountState = GeneralLedgerAccountsModule.filterByAccountState;
        this.dialog = false;
    }

    async save() {
        // Update the filters in the general ledger accounts module
        GeneralLedgerAccountsModule.updateAccountStateFilter(this.filterByAccountState);
        // Close dialog first then get general ledger accounts again
        this.dialog = false;
        await GeneralLedgerAccountsModule.getGeneralLedgerAccounts(1);
    }

}
